export function normalizeFormValidateResult(editor, data) {
  if (typeof data === 'string') {
    return Object.seal({
      editor,
      message: data
    });
  }
  if (data instanceof Error) {
    return Object.seal({
      editor,
      message: data.message,
      error: data
    });
  }
  if (typeof data === 'object' && data !== null) {
    var _data$message;
    return Object.seal({
      message: String((_data$message = data.message) !== null && _data$message !== void 0 ? _data$message : '未知错误'),
      ...data,
      editor
    });
  }
  return Object.seal({
    editor,
    message: '未知错误'
  });
}
//# sourceMappingURL=FormValidateResult.js.map
